var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"image-round",style:(_vm.setImageSize)})}
var staticRenderFns = []

export { render, staticRenderFns }